import { ChangeDetectionStrategy, Component, inject, input, output, signal } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { WarningIconComponent } from '@kuiper/icons';
import { RichEditorDualLangTextAreaComponent } from '../../../../../../ui-components/lib/rich-editor-dual-lang-text-area/rich-editor-dual-lang-text-area.component';
import { ValidationMessageComponent } from '../../../../../../ui-components/lib/validation-message/validation-message.component';
import { PaginatedSelectComponent } from '../../../../../../ui-components/lib/paginated-select/paginated-select.component';
import { baseUrl } from '../../../../../common/constants/endpoints.constants';

@Component({
  selector: 'lib-reject-send-back-modal',
  imports: [
    ReactiveFormsModule,
    TranslocoPipe,
    RichEditorDualLangTextAreaComponent,
    ValidationMessageComponent,
    PaginatedSelectComponent,
    WarningIconComponent,
  ],
  templateUrl: './reject-send-back-modal.component.html',
  styleUrl: './reject-send-back-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class RejectSendBackModalComponent {
  translocoService = inject(TranslocoService);
  fb = inject(FormBuilder);
  stepId = input.required<string | number>();
  closeModal = output<void>();
  submitSendBack = output<any>();
  baseUrl = baseUrl;

  sendBackForm = signal<FormGroup>(
    this.fb.group({
      position: ['', Validators.required],
      reason_option_id: ['', Validators.required],
      comment: ['', [Validators.required]],
    })
  );

  onSubmit(): void {
    if (this.sendBackForm().valid) {
      const formValue = this.sendBackForm().getRawValue();
      this.submitSendBack.emit(formValue);
    } else {
      this.sendBackForm().markAsDirty();
      this.sendBackForm().markAllAsTouched();
    }
  }

  onClose(): void {
    this.closeModal.emit();
  }
}
